import {
  DATA_CONNECTOR_SAVE_DATA_IN_EXTERNALDATABASE_BEGIN,
  DATA_CONNECTOR_SAVE_DATA_IN_EXTERNALDATABASE_SUCCESS,
  DATA_CONNECTOR_SAVE_DATA_IN_EXTERNALDATABASE_FAILURE,
  DATA_CONNECTOR_SAVE_DATA_IN_EXTERNALDATABASE_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
export function saveDataInExternaldatabase(args = {}) {
  return (dispatch) => {
    dispatch({
      type: DATA_CONNECTOR_SAVE_DATA_IN_EXTERNALDATABASE_BEGIN,
    });
    const header = builderSurfaceJsonContentHeader(args.projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.post(
        `${process.env.REACT_APP_BUILDER_ENGINE}${args.version}/appwrites/create`,
        args,
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: DATA_CONNECTOR_SAVE_DATA_IN_EXTERNALDATABASE_SUCCESS,
            data: res.data,
          });
          resolve(res.data);
        },
        (err) => {
          dispatch({
            type: DATA_CONNECTOR_SAVE_DATA_IN_EXTERNALDATABASE_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissSaveDataInExternaldatabaseError() {
  return {
    type: DATA_CONNECTOR_SAVE_DATA_IN_EXTERNALDATABASE_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case DATA_CONNECTOR_SAVE_DATA_IN_EXTERNALDATABASE_BEGIN:
      return {
        ...state,
        saveDataInExternaldatabasePending: true,
        saveDataInExternaldatabaseError: null,
      };

    case DATA_CONNECTOR_SAVE_DATA_IN_EXTERNALDATABASE_SUCCESS:
      return {
        ...state,
        saveDataInExternaldatabasePending: false,
        saveDataInExternaldatabaseError: null,
        externalDbUuid: action.data.uuid,
      };

    case DATA_CONNECTOR_SAVE_DATA_IN_EXTERNALDATABASE_FAILURE:
      return {
        ...state,
        saveDataInExternaldatabasePending: false,
        saveDataInExternaldatabaseError: action.data.error,
      };

    case DATA_CONNECTOR_SAVE_DATA_IN_EXTERNALDATABASE_DISMISS_ERROR:
      return {
        ...state,
        saveDataInExternaldatabaseError: null,
      };

    default:
      return state;
  }
}
